// src/pages/Home.tsx
import React from 'react';
import { Helmet } from 'react-helmet-async';
import HeroBanner from '../components/HeroBanner/HeroBanner.tsx';
import ServiceCards from '../components/ServiceCards/ServiceCards.tsx';
import WhyChoose from '../components/WhyChoose/WhyChoose.tsx';
import Testimonials from '../components/Testimonials/Testimonials.tsx';
import BlogSection from '../components/BlogSection/BlogSection.tsx';

const Home: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Vedic Astrologer | Kundali & Jyotish Readings Online | Kavitha Nandy</title>
        <meta name="description" content="Personalised Vedic astrology readings with Astrologer Kavitha Nandy: kundali analysis, birth chart, jyotish, Vaastu Shastra & career guidance. Remote consultations across the USA from $25." />
        <link rel="canonical" href="https://cosmickavi.com/" />
      </Helmet>
      <HeroBanner />
      <ServiceCards />
      <WhyChoose />
      <Testimonials />
      <BlogSection />
    </>
  );
};

export default Home;